module.exports = __webpack_public_path__ + "media/images/flags/64/Honduras-fdec813a39ff3875cf62ccedc835464a.png";